// src/pages/Forbidden/ForbiddenPage.jsx
import React from 'react';

const ForbiddenPage = () => (
  <div className="container py-5">
    <h1 className="mb-3">403 — Not authorized</h1>
    <p>You don’t have permission to access this page.</p>
  </div>
);

export default ForbiddenPage;
